/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Event History Location Icon component.
 */
export const EventHistoryLocationIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M11.9997 1.25C19.5358 1.25001 23.5346 10.1528 18.528 15.7852L12.5602 22.498C12.4179 22.658 12.2138 22.75 11.9997 22.75C11.7856 22.7499 11.5813 22.658 11.4391 22.498L5.47135 15.7852C0.465115 10.1529 4.46393 1.25036 11.9997 1.25ZM11.9997 6.25C9.92876 6.25019 8.24967 7.92905 8.24967 10C8.24967 12.071 9.92876 13.7498 11.9997 13.75C14.0707 13.75 15.7497 12.0711 15.7497 10C15.7497 7.92893 14.0707 6.25 11.9997 6.25Z' fill={iconColor} />
    </svg>
  );
};

export default EventHistoryLocationIcon;
